module.exports = __webpack_public_path__ + "assets/adpoly-facility-canteens-bulk-upload-template.0eaa1b20.xlsx";